import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Close icon — X mark. */
const CloseIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M13.6464 5.64645C13.8417 5.45118 14.1582 5.45119 14.3535 5.64645C14.5487 5.84171 14.5487 6.15822 14.3535 6.35348L10.707 9.99996L14.3535 13.6464C14.5487 13.8417 14.5487 14.1582 14.3535 14.3535C14.1582 14.5487 13.8417 14.5487 13.6464 14.3535L9.99996 10.707L6.35348 14.3535C6.15822 14.5487 5.84171 14.5487 5.64645 14.3535C5.45119 14.1582 5.45118 13.8417 5.64645 13.6464L9.29293 9.99996L5.64645 6.35348C5.45119 6.15821 5.45119 5.84171 5.64645 5.64645C5.84171 5.45119 6.15822 5.45119 6.35348 5.64645L9.99996 9.29293L13.6464 5.64645Z" fill="currentColor" />
  </svg>
);

export default CloseIcon;
